import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { CONFIRMATION } from "../../../../redux/action/type.action";

const useStyles = makeStyles((theme) => ({
  dialogBox: {
    minWidth: theme.spacing(65),
    minHeight: theme.spacing(7),
    maxWidth: "unset",
  },
}));

const ComfirmationComponent = (props: any) => {
  const dispatch = useDispatch();
  let reducer = useSelector((state: any) => state[CONFIRMATION.name]);
  const [state, setState]: any = useState(reducer);
  const classes = useStyles();

  useEffect(() => {
    setState(reducer);
  }, [reducer]);

  const handleClose = () => {
    if (state.handleClose) {
      state.handleClose();
    }
    dispatch({
      type: CONFIRMATION.clear,
    });
  };
  return (
    <Dialog
      open={state?.open}
      onClose={handleClose}
      aria-labelledby={state?.title}
      classes={{
        paper: classes.dialogBox,
      }}
    >
      <DialogTitle>{state?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{state?.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {state?.actions &&
          state.actions.map((component, index) => (
            <React.Fragment key={index}>{component}</React.Fragment>
          ))}
        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ComfirmationComponent;

type confirmationObjectType = {
  handleClose?: (value: any) => void;
  message?: string | React.ReactNode;
  actions?: any;
  title: string | React.ReactNode;
};

export const CONFIRMATION_OPEN = (object: confirmationObjectType) => {
  const { handleClose, message, actions, title } = object;
  return {
    type: CONFIRMATION.set,
    payload: {
      open: true,
      handleClose: handleClose ? handleClose : null,
      message: message ? message : null,
      actions: actions ? actions : null,
      title: title ? title : null,
    },
  };
};
